import React from "react"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import Tabs from '../Tabs/Tabs'
import DatesAndTimesPresenterTabContent from "./DatesAndTimesPresenterTabContent"


class DatesAndTimesPresenter extends React.Component {

  constructor(props) {
    // console.log('RTB', this.props);
    super(props);
    this.state = {
      loading: false,
      date_format: this.props.date_setting.date_format || null,
      time_format: this.props.date_setting.time_format || null,
      time_zone: this.props.date_setting.time_zone || null,
      date_setting_revision_history_path: this.props.date_setting_revision_history_path,
      active_tab: 'general',

    }
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    // this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this);
  }

  componentDidMount() {
    var self = this
    $(window).on("datesAndTimesSaved", function () {
      $.ajax({
        type: 'POST',
        url: '/admin/dates-and-times/data',
      }).done((data) => {
        self.setState({
          date_format: data.date_setting.date_format,
          time_format: data.date_setting.time_format,
          time_zone: data.date_setting.time_zone,
        })
      })
    });
  }

  render() {
    return (
      <div className="dates-and-times-builder">
        <Tabs tabs={this.Tabs()} />
        <div className="panel panel-form">
          <DatesAndTimesPresenterTabContent {...this.state} {...this.props} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  onChangeActiveTab(name) {
    this.setState({
      active_tab: name
    });
  };

  Tabs() {
    if(this.props.historical_view == true) {
      
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          }, 
        ]
      )
    } else {

      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('history'),
            targetName: 'history',
            classes: this.state.active_tab === 'history' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          }
        ]
      );
    }
  };

};

export default DatesAndTimesPresenter
